import { Form, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';

import { FaqFormField } from './type';

export const AddFaqForm = () => {
  return (
    <FormSectionsSeparator title={""}>
      
      {/* Question English */}
      <Form.Item<FaqFormField>
        label="Question English"
        name={FaqFormField.question}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input placeholder="Enter question in English" />
      </Form.Item>

      {/* Answer English */}
      <Form.Item<FaqFormField>
        label="Answer English"
        name={FaqFormField.answer}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <TextArea rows={4} placeholder="Enter answer in English" />
      </Form.Item>

      {/* Question Arabic */}
      <Form.Item<FaqFormField>
        label="Question Arabic"
        name={FaqFormField.question_Arabic}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input placeholder="Enter question in Arabic" />
      </Form.Item>

      {/* Answer Arabic */}
      <Form.Item<FaqFormField>
        label="Answer Arabic"
        name={FaqFormField.answer_Arabic}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <TextArea rows={4} placeholder="Enter answer in Arabic" />
      </Form.Item>

    </FormSectionsSeparator>
  );
};